/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function IconoMicrosoft(e) {
  let t = (0, ReactCompiler.c)(6),
    { className: n } = e,
    r = n === void 0 ? `h-4 w-4` : n,
    i,
    a,
    o,
    s;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = <rect x={`1`} y={`1`} width={`9`} height={`9`} fill={`#f25022`} />),
      (a = <rect x={`1`} y={`11`} width={`9`} height={`9`} fill={`#00a4ef`} />),
      (o = <rect x={`11`} y={`1`} width={`9`} height={`9`} fill={`#7fba00`} />),
      (s = (
        <rect x={`11`} y={`11`} width={`9`} height={`9`} fill={`#ffb900`} />
      )),
      (t[0] = i),
      (t[1] = a),
      (t[2] = o),
      (t[3] = s))
    : ((i = t[0]), (a = t[1]), (o = t[2]), (s = t[3]));
  let c;
  return (
    t[4] === r
      ? (c = t[5])
      : ((c = (
          <svg
            viewBox={`0 0 21 21`}
            className={r}
            aria-hidden={`true`}
            children={[i, a, o, s]}
          />
        )),
        (t[4] = r),
        (t[5] = c)),
    c
  );
}
